import { toRefs, computed } from 'vue';

//

/**
 * The Ratio Box dynamically sets its height based on its width (via CSS)
 * to maintain a fixed aspect ratio at all times.
 *
 * This is most commonly useful to make a perfect square when whe width
 * is dynamic.
 */
var script = {
  name: 'RatioBox',
  props: {
    ratio: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    const {
      ratio
    } = toRefs(props);
    const styles = computed(() => {
      return {
        '--c-padding-top': `${1 / ratio.value * 100}%`
      };
    });
    return {
      styles
    };
  }
};
export { script as default };